import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin, isAdminAuthenticated } from '../../lib/admin';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isAdminAuthenticated()) navigate('/admin/lotes-editor');
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await adminLogin(email.trim(), password);
      navigate('/admin/lotes-editor');
    } catch (e) {
      setErr(e.message || 'Error de autenticación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.root} data-testid="admin-login">
      <div style={styles.card}>
        <div style={styles.brand}>
          <div style={styles.kicker}>SANTA MÓNICA · ADMIN</div>
          <h1 style={styles.title}>Acceso interno</h1>
          <p style={styles.subtitle}>Editor de lotes y plan maestro</p>
        </div>
        <form onSubmit={onSubmit} style={styles.form}>
          <label style={styles.label}>
            <span>Correo</span>
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={styles.input}
              placeholder="admin@santamonica.mx"
              data-testid="admin-email-input"
            />
          </label>
          <label style={styles.label}>
            <span>Contraseña</span>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="••••••••"
              data-testid="admin-password-input"
            />
          </label>
          {err && <div style={styles.error} data-testid="admin-login-error">{err}</div>}
          <button
            type="submit"
            disabled={loading}
            style={{ ...styles.btn, opacity: loading ? 0.6 : 1 }}
            data-testid="admin-login-submit"
          >
            {loading ? 'Verificando…' : 'Entrar'}
          </button>
        </form>
        <div style={styles.footer}>
          Solo personal autorizado. Las acciones quedan registradas.
        </div>
      </div>
    </div>
  );
}

const styles = {
  root: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0e1e2e 0%, #163148 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2rem',
    fontFamily: 'system-ui, -apple-system, "Segoe UI", sans-serif',
  },
  card: {
    width: '100%',
    maxWidth: '420px',
    background: 'rgba(255,255,255,0.97)',
    borderRadius: '14px',
    boxShadow: '0 25px 70px rgba(0,0,0,0.45)',
    padding: '2.5rem 2rem 2rem',
  },
  brand: { textAlign: 'left', marginBottom: '1.5rem' },
  kicker: {
    fontSize: '0.7rem',
    letterSpacing: '0.18em',
    color: '#f6802c',
    fontWeight: 700,
    marginBottom: '0.5rem',
  },
  title: {
    fontSize: '1.6rem',
    color: '#0e1e2e',
    margin: 0,
    fontWeight: 600,
  },
  subtitle: {
    color: '#5a6877',
    fontSize: '0.9rem',
    marginTop: '0.3rem',
  },
  form: { display: 'flex', flexDirection: 'column', gap: '1rem' },
  label: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.35rem',
    fontSize: '0.85rem',
    color: '#3c4a5a',
    fontWeight: 500,
  },
  input: {
    border: '1px solid #d2d8df',
    borderRadius: '8px',
    padding: '0.7rem 0.9rem',
    fontSize: '0.95rem',
    outline: 'none',
    transition: 'border 0.15s',
  },
  btn: {
    background: '#f6802c',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    padding: '0.85rem 1rem',
    fontSize: '0.95rem',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: '0.5rem',
    letterSpacing: '0.02em',
  },
  error: {
    background: '#fef2f2',
    border: '1px solid #fecaca',
    color: '#b91c1c',
    padding: '0.6rem 0.8rem',
    borderRadius: '6px',
    fontSize: '0.85rem',
  },
  footer: {
    marginTop: '1.5rem',
    fontSize: '0.75rem',
    color: '#9aa4ad',
    textAlign: 'center',
  },
};
